/* global jQuery */

import moment from 'moment';
import _ from 'lodash';

moment.locale('fr');

export const utils = {
    getDomainFromUrl: function() {
        // Return domain name from URL
        return window.location.hostname;
    },
    sleep: function(ms) {
        // Sleep given ms before returning
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    getCookie: function(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === name + '=') {
                    cookieValue = decodeURIComponent(
                        cookie.substring(name.length + 1),
                    );
                    break;
                }
            }
        }
        return cookieValue;
    },
    deepCopy: function(object) {
        if (object !== undefined) {
            return JSON.parse(JSON.stringify(object));
        }
        return {};
    },
    deepCopyAndSnakeCase: function(object) {
        if (object !== undefined) {
            if (object === null) {
                return null;
            }
            if (typeof object !== 'object') {
                return object;
            }
            if (Array.isArray(object)) {
                return object; // TODO faire une boucle récursive sur le tableau
            }
            let newObject = {};
            for (let prop in object) {
                newObject[_.snakeCase(prop)] = this.deepCopyAndSnakeCase(object[prop]);
            }
            return newObject;
        }
        return {};
    },
    deepCopyAndCamelCase: function(object) {
        if (object !== undefined) {
            if (object === null) {
                return null;
            }
            if (typeof object !== 'object') {
                return object;
            }
            if (Array.isArray(object)) {
                return object; // TODO faire une boucle récursive sur le tableau
            }
            let newObject = {};
            for (let prop in object) {
                newObject[_.camelCase(prop)] = this.deepCopyAndCamelCase(object[prop]);
            }
            return newObject;
        }
        return {};
    },
    formatDate: function(date) {
        return moment(date).format('DD/MM/YYYY');
    },
    formatMonth: function(date) {
        return moment(date).format('MM/YYYY');
    },
    formatMonthByName: function(date) {
        return moment(date).format('MMMM YYYY');
    },
    formatDateAndHour: function(date) {
        return moment(date).format('DD/MM/YYYY à HH:mm');
    },
    deltaDate: function(input, days, months, years) {
        var date = new Date(input);
        date.setDate(date.getDate() + days);
        date.setMonth(date.getMonth() + months);
        date.setFullYear(date.getFullYear() + years);
        return date;
    },
};
